/**
 * Validates that the given string is a number.
 */
export const isNumberString = (value: string) => {
  return value.match(/^-?\d+(\.\d+)?$/) && !Number.isNaN(parseFloat(value));
};
